// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ce5ba7e0","483":"c739e9a6","787":"d52e46ab"}[chunkId] + ".chunk.js";
};